import { useEffect, type FunctionComponent, type PropsWithChildren } from 'react';
import { initialize as initializeAnalytics, trackPageLoad } from '@fff-web/fff-analytics';
import { IntroProductNav, NewMemberNavTemplate } from '@fff-web/fff-global-nav';
import { useUserContext } from '@fff-web/fff-utilities';
import env from '../../config/env';
import { usePersonalSurveyContext } from '../../contexts/PersonalSurveyContext';
import navBarSteps from '../../utils/navBarSteps';
import { redirectToLogin } from '../../utils/redirectMethods';

const PrivateRoute: FunctionComponent<PropsWithChildren> = ({ children }) => {
  initializeAnalytics();
  const { userInfo } = useUserContext();
  const { isEditCampaignOpen, hasNMCAccess, isLoadingNMC } = usePersonalSurveyContext();

  useEffect(() => {
    if (!userInfo.loggedIn) redirectToLogin();
    const wooUserId = userInfo.user.userId;
    if (wooUserId) trackPageLoad().then();
  }, [userInfo]);

  if (!userInfo.loggedIn || isLoadingNMC) return null;

  return (
    <>
      {/* TO DO: refactor universal-navigation so that logic lives there */}
      {hasNMCAccess ? (
        <NewMemberNavTemplate
          env={env.ENVIRONMENT}
          step={navBarSteps.SURVEY}
          isEditCampaignOpen={isEditCampaignOpen}
        />
      ) : (
        <IntroProductNav envName={env.ENVIRONMENT} />
      )}
      {children}
    </>
  );
};

export default PrivateRoute;
